// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.modal {
  visibility: collapse;
  display: inherit;
}
div.modal div.backdrop {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.75);
  z-index: 1;
  top: 0;
  left: 0;
}
div.modal div.box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  z-index: 2;
  box-sizing: border-box;
  width: min(760px, 95vw);
  max-height: 90vh;
  overflow: auto;
  border-radius: 8px;
}
div.modal div.box div.close {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 3;
  border-radius: 50%;
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(222, 41, 34);
  cursor: pointer;
}
div.modal div.box div.close:hover {
  background-color: #444;
}
div.modal div.box div.close i.fa {
  font-size: 18px;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modal/modal.component.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAEA;EACI,oBAAA;EACA,gBAAA;AADJ;AAGI;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,qCAAA;EACA,UAAA;EACA,MAAA;EACA,OAAA;AADR;AAII;EACI,eAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,uBAAA;EACA,UAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAFR;AAIQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kCChCH;EDiCG,eAAA;AAFZ;AAIY;EACI,sBC5CJ;AD0CZ;AAKY;EACI,eAAA;EACA,YAAA;AAHhB","sourcesContent":["@use 'colors' as *;\n\ndiv.modal {\n    visibility: collapse;\n    display: inherit;\n\n    div.backdrop {\n        position: fixed;\n        height: 100vh;\n        width: 100vw;\n        background-color: rgba(0,0,0,0.75);\n        z-index: 1;\n        top: 0;\n        left: 0;\n    }\n\n    div.box {\n        position: fixed;\n        top: 50%;\n        left: 50%;\n        transform: translate(-50%, -50%);\n        background-color: white;\n        z-index: 2;\n        box-sizing: border-box;\n        width: min(760px, 95vw);\n        max-height: 90vh;\n        overflow: auto;\n        border-radius: 8px;\n\n        div.close {\n            position: absolute;\n            top: 8px;\n            right: 8px;\n            z-index: 3;\n            border-radius: 50%;\n            height: 36px;\n            width: 36px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            background-color: $cv-red;\n            cursor: pointer;\n\n            &:hover {\n                background-color: $text-dark;\n            }\n\n            i.fa {\n                font-size: 18px;\n                color: white;\n            }\n        }\n    }\n}\n","$text-dark: #444;\n\n$dark-gray: rgba(0,0,0,0.6);\n$light-gray: rgba(0,0,0,0.10);\n\n$dates-background: rgba(0,0,0,0.05);\n\n// cornelsen colors\n$cv-red: rgb(222,41,34);\n$cv-grass-dark: rgb(107,171,45);\n$cv-grass-medium: rgb(177,198,16);\n$cv-grass-light: rgb(220,235,205);\n$cv-sky-dark: rgb(0,148,170);\n$cv-sky-medium: rgb(109,186,210);\n$cv-sky-light: rgb(210,235,235);\n$cv-sand-dark: rgb(175,157,140);\n$cv-sand-medium: rgb(212,202,189);\n$cv-sand-light: rgb(240,230,225);\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
